import axios from './index';

export const getAPIAccessKeyRequest = (filterObj = {}) => {
  const { issuerID, userID, status } = filterObj;
  return axios.get(
    `v1/admins/api-access-keys/get/api-access-keys/-/${issuerID || '-'}/${
      userID || '-'
    }/${status || '-'}/-/-`
  );
};

export const createAPIAccessKeyRequest = (payload) =>
  axios.post('v1/admins/api-access-keys/create/api-access-key', payload);

export const updateAPIAccessKeyRequest = (id, payload) =>
  axios.put(`v1/admins/api-access-keys/update/api-access-key/${id}`, payload);

export const toggleAccessKeyStatusRequest = (id, payload) =>
  axios.put(
    `v1/admins/api-access-keys/toggle/api-access-key/${id}/access-status`,
    payload
  );

export const deleteAccessKeyStatusRequest = (id) =>
  axios.delete(`v1/admins/api-access-keys/delete/api-access-key/${id}`);

// issuer
export const getIssuerAPIAccessKeyRequest = (filterObj = {}) => {
  const { issuerID, userID, status } = filterObj;
  return axios.get(
    `v1/issuer-staffs/api-access-keys/get/api-access-keys/-/${
      issuerID || '-'
    }/${status || '-'}/-`
  );
};

export const createIssuerAPIAccessKeyRequest = (payload) =>
  axios.post('v1/issuer-staffs/api-access-keys/create/api-access-key', payload);

export const updateIssuerAPIAccessKeyRequest = (id, payload) =>
  axios.put(
    `v1/issuer-staffs/api-access-keys/update/api-access-key/${id}`,
    payload
  );

export const toggleIssuerAccessKeyStatusRequest = (id, payload) =>
  axios.put(
    `v1/issuer-staffs/api-access-keys/toggle/api-access-key/${id}/access-status`,
    payload
  );
